var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house-chimney-blank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 12.0162C22 11.86 21.9363 11.7049 21.8114 11.5936L19.7735 9.7667C19.7735 9.77001 19.7736 9.7634 19.7735 9.7667L19.7744 4.69151C19.7744 4.38002 19.5255 4.15969 19.2492 4.15969L15.942 4.15995C15.6344 4.15995 15.4169 4.41198 15.4169 4.69177L15.3229 5.7953L12.3523 3.14077C12.2474 3.04723 12.1159 3 11.9843 3C11.8529 3 11.7213 3.04723 11.6164 3.14077L2.18858 11.5936C2.06366 11.7063 2 11.8612 2 12.0162C2 12.3305 2.25182 12.5794 2.55816 12.5794C2.68885 12.5794 2.81972 12.5331 2.92436 12.4387L4.2257 11.2758L4.22589 18.2141C4.22589 19.768 5.47402 21 6.97671 21H16.9611C18.4951 21 19.7119 19.7367 19.7119 18.2141L19.7119 11.2758L21.1062 12.4388C21.2117 12.5335 21.3431 12.548 21.4742 12.548C21.7774 12.548 22 12.3297 22 12.0162ZM16.4357 5.25397H18.6301V8.77949L16.4357 6.79062V5.25397ZM18.6614 10.3256V18.1832C18.6614 19.1155 17.9127 19.8421 17.0235 19.8421H7.00781C6.08728 19.8421 5.36983 19.0838 5.36983 18.1832V10.3256C5.36983 10.3124 5.36324 10.3013 5.36236 10.2882L12.0156 4.31501L18.6997 10.2883C18.6997 10.301 18.6614 10.3116 18.6614 10.3256Z",
    fill: "#0D2E78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.25951ba700ab03fa43758e322dd24f1a.svg";
export { ForwardRef as ReactComponent };